import { times, cloneDeep } from 'lodash';
import createTaskType from '../../createTaskType';
import InformationTextEditor from "@dyl/task-types/A1/InformationText/Editor";

export default createTaskType({
    id: 'information_text',
    label: 'Information Text',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    editor: InformationTextEditor,
    createItemsTemplate: () => times(6, index => ({
        is_example: index === 0,

        // Only the example has rubric
        ...(index === 0 && {
            rubric_id: ''
        }),

        stimulus_text_1: '',
        stimulus_text_2: '',

        answers: times(3, index => ({
            is_correct_answer: false,
            text: '',
        })),
    })),

    convertToUploadFormat: (task, { isNew }) => {
        task = cloneDeep(task);

        task.items = task.items.map(x => {
            if (x.stimulus_text_1 === '') x.stimulus_text_1 = null;
            if (x.stimulus_text_2 === '') x.stimulus_text_2 = null;
            return x;
        });

        return task;
    },

    hasEndAudio: false,
    backgroundImages: {
        count: 1,
        configs: [
            {
                label: 'Background Image'
            }]
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x.text);
    }
});